import React, { useState } from 'react';
import UseCreationData from '../../api/UseCreationData';

import LabelCheckboxBtn from '../../components/LabelCheckboxBtn/LabelCheckboxBtn';
import closeGreen from '../../assets/img/close-green.svg';
import clear from '../../assets/img/clear.svg';
import ReactSelect from 'react-select';

const Stage = ({ id, appId, remove, chgSteps, input, webResourcesOptions }) => {
    const { creationData } = UseCreationData();
    const dataStages = creationData['action-data'].at1.apps.stages;
    const dataStagesWebResources = creationData['action-data'].at1_2.apps.stages;
    const dataFormat = dataStages.formats.options;
    const ndsClass = input.actionTypeId === 'at1_2' || input.actionTypeId === 'at2_2' ? 'nds-step' : '';

    function clearInputs(e) {
        const inputs = e.target.closest('.step').querySelectorAll('input');
        inputs.forEach((el) => (el.value = ''));
    }

    const [checkedOther, setCheckedOther] = useState(false);
    function onChangeCheckbox(event) {
        if (event.target.title === 'Другое' || event.target.value === 'f6') {
            setCheckedOther(event.target.checked);
        }
    }

    function changeNumber(e) {
        e.target.value = e.target.value.replace(/[A-Za-zА-Яа-я ]+/g, '');
        if (e.target.value !== '') {
            chgSteps(e);
        }
    }

    function parsePrice(value) {
        if (!value) {
            return null;
        }

        const cleaned = value.replace(/\s/g, '');

        if (cleaned.includes(',') && !cleaned.includes('.')) {
            const num = parseFloat(cleaned.replace(',', '.'));
            return Number.isNaN(num) ? null : num;
        }

        const normalized = cleaned.replace(/\./g, '');
        const num = parseFloat(normalized);
        return Number.isNaN(num) ? null : num;
    }

    function formatNds(value) {
        if (value == null) {
            return '';
        }

        const rounded = Math.round(value * 100) / 100;
        return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(2).replace(/\.?0+$/, '');
    }

    function updateNdsFromPrice(stepElement, priceValue) {
        const ndsInput = stepElement.querySelector(`input[name="apps-${appId}_stage-${id}_nds"]`);
        if (!ndsInput) {
            return;
        }

        const price = parsePrice(priceValue);
        const ndsValue = price != null ? formatNds((price / 105) * 5) : '';

        ndsInput.value = ndsValue;
        chgSteps({
            target: {
                name: ndsInput.name,
                value: ndsValue,
            },
        });
    }

    function changePriceNumber(e) {
        e.target.value = e.target.value.replace(/[A-Za-zА-Яа-я ]+/g, '');

        if (e.target.value !== '') {
            chgSteps(e);
        }

        if (input.actionTypeId === 'at1_2' || input.actionTypeId === 'at2_2') {
            updateNdsFromPrice(e.target.closest('.step'), e.target.value);
        }
    }

    return (
        <div
            className="step"
            id={id}
        >
            {id === 1 && (
                <div
                    className="clear-inputs"
                    onClick={clearInputs}
                >
                    Очистить поля{' '}
                    <i>
                        <img
                            src={clear}
                            alt=""
                        />
                    </i>
                </div>
            )}
            {id !== 1 && (
                <div
                    onClick={() => remove(id - 1)}
                    id={id}
                    className="delete-step"
                >
                    Удалить этап{' '}
                    <i>
                        <img
                            src={closeGreen}
                            alt=""
                        />
                    </i>
                </div>
            )}

            <b>Этап №{id}</b>
            <div className="step-wrap">
                <div className="step-content">
                    <div className="step-content-top">
                        <div className="step-content-top-item">
                            <input
                                type="text"
                                onChange={chgSteps}
                                className="step-input-name"
                                name={`apps-${appId}_stage-${id}_name`}
                                placeholder={dataStages.name.title}
                            />
                        </div>
                        <div className="step-content-top-flex-wrap">
                            <div className="step-content-top-item num">
                                <input
                                    type="text"
                                    min="0"
                                    onChange={(e) => changePriceNumber(e)}
                                    name={`apps-${appId}_stage-${id}_price`}
                                    placeholder={dataStages.price.title}
                                />
                            </div>
                            {(input.actionTypeId === 'at1_2' || input.actionTypeId === 'at2_2') && (
                                <>
                                    <span className="text-nds">включая НДС</span>

                                    <div className="step-content-top-item nds num">
                                        <input
                                            type="text"
                                            min="0"
                                            onChange={(e) => changeNumber(e)}
                                            name={`apps-${appId}_stage-${id}_nds`}
                                        />

                                        <div className="nds-note">Например: 100.000 руб., включая НДС 4761.9 руб.</div>
                                    </div>
                                </>
                            )}

                            <div className={`step-content-top-item ${ndsClass}`}>
                                <input
                                    type="text"
                                    onChange={chgSteps}
                                    name={`apps-${appId}_stage-${id}_time`}
                                    placeholder={dataStages.time.title}
                                />
                            </div>

                            {(input.actionTypeId === 'at1_2' || input.actionTypeId === 'at2_2') && (
                                <div className="step-content-top-item step-content-top-item-web-resources">
                                    <div className="small-title">{dataStagesWebResources['web-resources'].title}</div>
                                    <div className="content-select content-select-big">
                                        <ReactSelect
                                            options={webResourcesOptions}
                                            defaultValue=""
                                            required={dataStagesWebResources['web-resources'].required}
                                            classNamePrefix="react-select"
                                            className="react-select-container"
                                            onChange={(selectedOption) => {
                                                chgSteps({
                                                    target: {
                                                        name: `apps-${appId}_stage-${id}_web-resources`,
                                                        value: selectedOption ? selectedOption.value : '',
                                                    },
                                                });
                                            }}
                                            name={`apps-${appId}_stage-${id}_web-resources`}
                                            placeholder="Выберите один из вариантов"
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="step-content-bottom">
                        <b>{dataStages.formats.title}</b>
                        <span>Выберите один или несколько вариантов</span>
                        <div className="label-radio-btns-wrap">
                            {Object.keys(dataFormat).map((item) => {
                                return (
                                    <LabelCheckboxBtn
                                        changeLabelCheckbox={(e) => onChangeCheckbox(e)}
                                        key={dataFormat[item].id}
                                        name={`apps-${appId}_stage-${id}_formats[]`}
                                        value={dataFormat[item].id}
                                        title={dataFormat[item].title}
                                    />
                                );
                            })}
                        </div>
                    </div>

                    <div className={`adds-input${!checkedOther ? ' _hidden' : ''}`}>
                        <input
                            type="text"
                            name={`apps-${appId}_stage-${id}_other-format-text`}
                            placeholder="Введите форматы через запятую"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Stage;
